// prettier-ignore
export default {
    "DESCRIPTION": "Noi e terze parti utilizziamo cookie per finalit\u00e0 tecniche, di misurazione e marketing. Grazie al tuo consenso potremo migliorare l'esperienza utente, il rifiuto potrebbe rendere non disponibili le relative funzioni.",
    "POLICY": "Contratto",
    "ACCEPT": "Accetta",
    "REFUSE": "Rifiuta"
} as const